var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93909 12L13.9722 5.96955L15.0326 7.03044L10.0609 12L15.0326 16.9696L13.9722 18.0304L7.93909 12Z",
    fill: "#1F2328"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLined);
export default __webpack_public_path__ + "static/media/collapse-lined.c4f621cab42293013270076f4b9de52f.svg";
export { ForwardRef as ReactComponent };